export function recordFromSnapshot(snapshot) {
  let record = snapshot.val()
  record.key = snapshot.key
  return record
}
export function isValidKey(text) {
  return typeof text === 'string' && !text.match(/[.$[\]#/]/)
}
export function isValidKeyWithError(text) {
  let errorMessage =
    'Les caractères suivant ne peuvent pas être utilisés : ".", "#", "$", "[", ou "]"'
  if (typeof text === 'string' && !text.match(/[.$[\]#/]/)) {
    return { error: false, message: void 0 }
  } else {
    return { error: true, message: errorMessage }
  }
}



// WEBPACK FOOTER //
// ./src/utils/firebaseUtils.js